import { CustomMotion } from './CustomMotion';

export default class SecretTechniqueMotion extends CustomMotion {
  key = 'secret_technique_motion';
  frames = 0;
  transforms = {};
}
